import React from 'react';
import { ApolloError } from '@common/hooks';
import { Col } from 'antd';
import OrganizationUnitSelect from 'works/legacy/components/organization-unit-select/organization-unit-select';
import { RoleSelect } from '@clinician-profile/components';
import { RoleType } from '@clinician-profile/graphql';
import { ErrorHandler } from '@common/components';

type UnitRoleSelectProps = {
  rolesData?: RoleType[];
  rolesLoading: boolean;
  rolesError?: ApolloError;
  permittedDepartment: boolean;
};

export const UnitRoleSelect = ({
  rolesData,
  rolesLoading,
  rolesError,
  permittedDepartment,
}: UnitRoleSelectProps) => (
  <>
    <Col span={12}>
      <OrganizationUnitSelect
        scope={permittedDepartment ? 'department' : 'default'}
      />
    </Col>
    <Col span={12}>
      {rolesError ? (
        <ErrorHandler error={rolesError} log="ShiftForm" />
      ) : (
        <RoleSelect roles={rolesData} loading={rolesLoading} />
      )}
    </Col>
  </>
);
